/**
 * Shared UI primitives for the admin dashboard panels.
 */
import React from "react";

export const CENTS = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const fmtDate = (isoOrEpoch) => {
  if (!isoOrEpoch) return "";
  if (typeof isoOrEpoch === "number") return new Date(isoOrEpoch * 1000).toLocaleDateString();
  return new Date(isoOrEpoch).toLocaleDateString();
};

export const PACKAGE_LABEL = {
  ai_unlock_30d: "AI critic (30d)",
  advisor_monthly: "Advisor embed",
  advisor_listing_yearly: "Advisor listing",
  sponsor_homepage_monthly: "Homepage sponsor",
};

export const Tile = ({ title, children, testid }) => (
  <div
    data-testid={testid}
    className="bg-white border border-[#E5E2DC] rounded-2xl p-5"
  >
    <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold mb-3">
      {title}
    </div>
    {children}
  </div>
);

export const BigNum = ({ label, value, testid }) => (
  <div>
    <div className="text-xs text-[#5C6B62]">{label}</div>
    <div data-testid={testid} className="font-mono-num text-2xl text-[#1C2B23]">
      {value.toLocaleString()}
    </div>
  </div>
);

export function TextInput({ label, value, onChange, required, testid }) {
  return (
    <label className="block">
      <span className="text-[10px] text-[#5C6B62] font-medium">{label}</span>
      <input
        data-testid={testid}
        name={testid}
        required={required}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full bg-white border border-[#E5E2DC] rounded px-2 py-1 text-xs focus:outline-none focus:border-[#2B5339]"
      />
    </label>
  );
}
